import { useContext } from 'react';
import { AuthenticationContext } from '../context/AuthenticationProvider';

const useAuth = () => useContext(AuthenticationContext);

export default useAuth;
